(function(app) {

    app.directive("fillableFormTooltip",
    [
        "$compile", "$document", "$parse", function($compile, $document, $parse) {
            return {
                restrict: "A",
                scope: {
                    form: "=fillableFormTooltip"
                },
                link: function(scope, element, attrs) {
                    var tip = $compile("<div class=\"validate-tooltip tooltip-right\">" +
                        "<span class=\"exclamation\">{{ !!form.CompletedBy ? \"Great News!\" : \"Pending Form\"}}</span>" +
                        "<p class=\"info\" ng-if=\"!!form.CompletedBy\">Your form has cleared validation and is ready to be used in the transaction.</p>" +
                        "<p class=\"info\" ng-if=\"!form.CompletedBy\">Your form is currently pending validation and cannot be used in the transaction yet.</p>" +
                        "</div>")(scope);
                    var tipActiveClassName = "tooltip-show";

                    $document.find("body").append(tip);

                    element.bind("mouseover",
                        function(e) {
                            tip.addClass(tipActiveClassName);

                            var pos = e.target.getBoundingClientRect(),
                                offset = tip.offset(),
                                tipHeight = tip.outerHeight(),
                                elHeight = pos.height || pos.bottom - pos.top,
                                tipOffset = 20;

                            offset.top = pos.top - (tipHeight / 2) + (elHeight / 2) + 30;
                            offset.left = pos.right + tipOffset;

                            tip.offset(offset);
                        });

                    element.bind("mouseout",
                        function() {
                            tip.removeClass(tipActiveClassName);
                        });

                    tip.bind("mouseover",
                        function() {
                            tip.addClass(tipActiveClassName);
                        });

                    tip.bind("mouseout",
                        function() {
                            tip.removeClass(tipActiveClassName);
                        });
                }
            }
        }
    ]);

})(window.app); //jshint ignore:line